import { Ability, AbilityBuilder } from "@casl/ability";
import { UserAccessDetail } from "../models/user";
import { DigiProductCode, UserEntitlementCatalogValue } from "../models/UserEntitlements";
import { appConfig } from "../../app/pages/digitization/api/appConfig";

let ability = new Ability();

export const Can = ({ action, subject, productCode }: UserEntitlementCatalogValue): boolean => {
    if (appConfig.enableEntitlementEnforcement) {
        try {
            const { participant_id, product_code } = getUserDetail(productCode);

            const conditions = {
                subject: subject,
                participantId: participant_id,
                productCode: product_code
            };

            if (participant_id && product_code && conditions) {
                return ability.can(action, conditions);
            }

            return false;
        } catch (err) {
            return false;
        }
    } else {
        return true;
    }
}

export const setAbilities = (entitlements: UserEntitlementCatalogValue[]): void => {
    const { can, rules } = AbilityBuilder.extract();

    if (entitlements && entitlements.length > 0) {
        entitlements.map((entitlement: UserEntitlementCatalogValue) => {
            can(entitlement.action, {
                subject: entitlement.subject,
                participantId: entitlement.participantId,
                productCode: entitlement.productCode
            });
        })
    }

    ability = new Ability(rules);
}

export const mapAbilities = (entitlements: any): UserEntitlementCatalogValue[] => {
    const userEntitlements: UserEntitlementCatalogValue[] = [];

    entitlements.forEach(node => {
        node.permissionNames.forEach(name => {
            userEntitlements.push({
                action: name,
                subject: 'PermissionCheck',
                participantId: node.companyId,
                productCode: node.productCode   
            });
        });
    });

    return userEntitlements;
}

export const hasRole = (role: string) => {
  return Boolean(getUserDetails().find(s => s.participant_role === role));
}

export function getUserDetail(productCpde): UserAccessDetail {
    return JSON.parse(localStorage.getItem('b2c_user')).userAccessDetails.find(s => s.product_code === productCpde) as UserAccessDetail;
}

function getUserDetails(): UserAccessDetail[] {
  return JSON.parse(localStorage.getItem('b2c_user')).userAccessDetails.filter(s => s.product_code === DigiProductCode) as UserAccessDetail[];
}
